import axiosInstance from '../axiosInterceptor/axiosInstance'

const getStages = async ({ orgId, seasonId }) => {
  const url = `v1/orgs/${orgId}/stages?seasonId=${seasonId}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getStages
